/**
 * Per-user walkthrough flags (localStorage, v1 — see PRD §6.2).
 *
 * Keyed by Firebase UID so two users on the same browser profile never
 * share state, and one user's reset never touches another's:
 *
 *   bq_tour_seen:<uid>:<tourId>@v<version> = "<ISO timestamp>"
 *
 * v2 seam: sync to Neon via a /me/tour-flags API (server = source of truth,
 * localStorage = cache). Not built yet.
 */

export const TOUR_FLAG_PREFIX = 'bq_tour_seen:'

export function flagKey(uid: string, tourId: string, version: number): string {
  return `${TOUR_FLAG_PREFIX}${uid}:${tourId}@v${version}`
}

export function readFlag(uid: string, tourId: string, version: number): string | null {
  return window.localStorage.getItem(flagKey(uid, tourId, version))
}

export function writeFlag(uid: string, tourId: string, version: number): string {
  const ts = new Date().toISOString()
  window.localStorage.setItem(flagKey(uid, tourId, version), ts)
  return ts
}

export function clearFlag(uid: string, tourId: string, version: number): void {
  window.localStorage.removeItem(flagKey(uid, tourId, version))
}
